import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import { useAddCargoToTrip } from 'api/trips/use-add-cargos-to-trip.ts';
import { EFormDrawerSize, FormDrawerWithButton } from 'components/common/form-drawer-with-button';
import { SelectCargoForm } from './components/select-cargo-form';
import type { ISelectCargoFormFields } from './components/select-cargo-form/types';

interface ITripAddCargoDrawerWithButtonProps {
  tripId: number;
}

export const TripAddCargoDrawerWithButton = (props: ITripAddCargoDrawerWithButtonProps) => {
  const { tripId } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { mutateAsync: addCargoToTrip, isLoading } = useAddCargoToTrip();

  const handleFinish = async (values: ISelectCargoFormFields) => {
    await addCargoToTrip({
      tripId,
      cargoIds: [values.cargo.value],
    });

    form.resetFields();
  };

  return (
    <FormDrawerWithButton
      formComponent={SelectCargoForm}
      buttonLabel={t('cargo:add_cargo')}
      buttonType='default'
      title={t('cargo:add_cargo')}
      isLoading={isLoading}
      size={EFormDrawerSize.DEFAULT}
      onFinish={handleFinish}
    />
  );
};
